import React from 'react';
import { Grid } from 'semantic-ui-react';

import CommonTagsInputWrapper from '../../../common/CommonTagsInputWrapper';
import connect from 'react-redux/es/connect/connect';
import GridColumnInputWrapper from '../../../common/GridColumnInputWrapper';
import CommonSelectInputWrapper from '../../../common/CommonSelectInputWrapper';
import {
  Mode,
  isFalseOption,
  isTrueFalseOptions,
  isTrueOption,
  RISK_TYPE_HAZARD_BAND_CODE,
} from '../../../../constants';
import { AccordionWrapper, InputWrapper } from 'react-lib/dist/components-es';
import { getRiskOptions, modeChangedFromView } from '../../../../utils';

import { chemicalProductsActions } from '../../../../behavior/chemicalProducts';
import { hazardStatementsActions } from '../../../../behavior/hazardStatements/index';
import { risksActions } from '../../../../behavior/risks';

let bandOptions = [];

class CPChemicalInformationContainer extends React.Component {
  componentDidMount() {
    if (this.props.mode !== Mode.VIEW) this.loadOnStart();
    this.initOptions();
  }

  componentWillReceiveProps(newProps) {
    if (modeChangedFromView(this.props, newProps)) this.loadOnStart();
  }

  loadOnStart = () => {
    const { hazardStatementList } = this.props;
    if (!hazardStatementList || hazardStatementList.length === 0)
      this.props.getHazardStatementList();

    const { euhStatementList } = this.props;
    if (!euhStatementList || euhStatementList.length === 0)
      this.props.getEuhStatementList();
  };

  initOptions = () => {
    const { riskList } = this.props.initialData;
    const { values } = this.props;

    //band
    bandOptions = getRiskOptions(riskList, RISK_TYPE_HAZARD_BAND_CODE, values.chemicalProduct.band);
  };

  updateHazardBand = hazardStatements => {
    const { values } = this.props;
    let hazardStmtMaxBand = null;
    if (hazardStatements && hazardStatements.length > 0) {
      hazardStmtMaxBand = hazardStatements.reduce((p, c) => {
        return p.band.value > c.band.value ? p : c;
      });
    }
    values.chemicalProduct.band.id = hazardStmtMaxBand ? hazardStmtMaxBand.band.id : '';
    values.chemicalProduct.band.value = hazardStmtMaxBand ? hazardStmtMaxBand.band.value : '';
  };

  updateIsAerosol = hazardStatements => {
    const { values } = this.props;
    let isAerosol = null;
    if (hazardStatements && hazardStatements.length > 0) {
      isAerosol = hazardStatements.find(h => h.isAerosol);
    }
    values.chemicalProduct.isAerosol = isAerosol ? isTrueOption.value : isFalseOption.value;
  };

  onHazardStatementChange = hazardStatements => {
    this.updateHazardBand(hazardStatements);
    this.updateIsAerosol(hazardStatements);
    this.props.cmrClassCalculation();
    this.props.hazardsCalculation();
    this.props.chemRiskCalculation();
  };

  render() {
    return (
      <AccordionWrapper
        {...this.props}
        closable={false}
        accordionTitle="chemical.product.details.page.chemical.inf.container.title"
        className="containerReducedWhiteSpace"
        render={this.getChemicalInformationContainerContent}
      />
    );
  }

  isStateAny(anyIds) {
    const { state } = this.props.values.chemicalProduct;
    return state && anyIds.includes(state.id);
  }

  getEuhStatementContent = () => {
    const { values, errors, euhStatementList,  disabled, chemicalProductDisabled } = this.props;
  
    return (
      <Grid stackable columns={2} verticalAlign="bottom">
      <GridColumnInputWrapper
        {...this.props}
        name="chemicalProduct.euhStatements"
        label="chemical.product.details.page.chemical.inf.container.euh.statements.input"
        errors={errors}
        disabled={disabled || chemicalProductDisabled}
        render={(props) => (
          <CommonTagsInputWrapper
            {...props}
            suggestionList={euhStatementList}
            matchProperty="statement"
            displayProps="statement"
            value={values.chemicalProduct.euhStatements}
            onlyUnique={true}
          />
        )}
      />
      <GridColumnInputWrapper
        {...this.props}
        fieldClassName="checkboxMargin"
        inputClassName="checkboxLabelOnTop"
        value={values.chemicalProduct.isEuhNotApplicable}
        name="chemicalProduct.isEuhNotApplicable"
        label="chemical.product.details.page.chemical.inf.container.is.not.euhapplicable.input"
        type="checkbox"
        disabled={disabled || chemicalProductDisabled}
        render={(props) => <InputWrapper {...props}/>}
      />
    </Grid>
    )
  }

  getChemicalInformationContainerContent = () => {
    const { values, errors, hazardStatementList,  disabled, chemicalProductDisabled } = this.props;

    if (!values.chemicalProduct.band) values.chemicalProduct.band = {};
    values.chemicalProduct.isAerosol =
      values.chemicalProduct.isAerosol === true || values.chemicalProduct.isAerosol === 'true'
        ? 'true'
        : 'false';

    return (
      <Grid columns={3}>
          <GridColumnInputWrapper
            {...this.props}
            name="chemicalProduct.hazardStatements"
            label="chemical.product.details.page.chemical.inf.container.hazard.statements.input"
            errors={errors}
            disabled={disabled || chemicalProductDisabled}
            render={(props) => (
              <CommonTagsInputWrapper
                {...props}
                suggestionList={hazardStatementList}
                matchProperty="statement"
                displayProps="statement"
                value={values.chemicalProduct.hazardStatements}
                onlyUnique={true}
                onSelect={this.onHazardStatementChange}
              />
            )}
          />
          <GridColumnInputWrapper
            {...this.props}
            value={values.chemicalProduct.band.id}
            name="chemicalProduct.band.id"
            label="chemical.product.details.page.chemical.inf.container.hazard.band.input"
            options={bandOptions}
            disabled={true}
            render={props => <CommonSelectInputWrapper {...props} />}
          />
          <GridColumnInputWrapper
            {...this.props}
            value={values.chemicalProduct.isAerosol}
            name="chemicalProduct.isAerosol"
            label="chemical.product.details.page.chemical.inf.container.is.aerosol.input"
            options={isTrueFalseOptions}
            disabled={true}
            render={props => <CommonSelectInputWrapper {...props} />}
          />

          <GridColumnInputWrapper
            {...this.props}
            fieldClassName="checkboxMargin"
            inputClassName="checkboxLabelOnTop"
            value={values.chemicalProduct.isNotHazardous}
            name="chemicalProduct.isNotHazardous"
            label="chemical.product.details.page.chemical.inf.container.is.not.hazardous.input"
            type="checkbox"
            disabled={disabled || chemicalProductDisabled}
            render={props => <InputWrapper {...props} />}
          />
          <GridColumnInputWrapper
            {...this.props}
            fieldClassName="checkboxMargin"
            inputClassName="checkboxLabelOnTop"
            value={values.chemicalProduct.isCernMixture}
            name="chemicalProduct.isCernMixture"
            label="chemical.product.details.page.chemical.inf.container.is.cern.mixture.input"
            type="checkbox"
            disabled={disabled || chemicalProductDisabled}
            render={props => <InputWrapper {...props} />}
          />
        <Grid.Column width={16}>
          <AccordionWrapper
            closable={true}
            collapsed={false}
            accordionTitle="chemical.product.details.page.chemical.info.euh.statement.container.title"
            render={this.getEuhStatementContent}
          />
        </Grid.Column>
      </Grid>
    );
  };
}

const mapStateToProps = state => ({
  ...state.hazardStatements
});

const mapDispatchToProps = dispatch => ({
  getHazardStatementList: () =>
    dispatch(hazardStatementsActions.getHazardStatementAutocompleteList()),
  chemRiskCalculation: () => dispatch(risksActions.chemRiskCalculation()),
  cmrClassCalculation: () => dispatch(chemicalProductsActions.cmrClassCalculation()),
  hazardsCalculation: () => dispatch(chemicalProductsActions.hazardsCalculation()),
  getEuhStatementList: () =>
    dispatch(hazardStatementsActions.getEuhStatementAutocompleteList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CPChemicalInformationContainer);
